import React, { useState } from "react";
import "./settingsSidebar.css";
import AboutUsPage from "./settingsComponents/aboutUsPage";
import AllList from "./settingsComponents/allListPage";
import AdminPage from "./settingsComponents/adminPage";
import TransactionPage from "./settingsComponents/transactionPage";
import ContactNumber from "./settingsComponents/contactNumber";

const SettingsSideBar = () => {
  const [selectedPage, setSelectedPage] = useState("aboutUsPage");

  const renderContent = () => {
    switch (selectedPage) {
      case "aboutUsPage":
        return <AboutUsPage  />;
      case "alllist":
        return <AllList/>;
      case "adminPage":
        return <AdminPage/>;
      case "transaction":
        return <TransactionPage/>;
      case "contactnumber":
        return <ContactNumber/>;

    }
  };

  return (
    <div style={{ display: "flex" }}>
      {/* Sidebar */}
      <div className="sidebarContainer">
        <ul className="submenuClient">
          <li onClick={() => setSelectedPage("aboutUsPage")}>About us pages</li>
          <li onClick={() => setSelectedPage("alllist")}>All list</li>
          <li onClick={() => setSelectedPage("adminPage")}>Admin Page</li>
          <li onClick={() => setSelectedPage("transaction")}>Transaction</li>
          <li onClick={() => setSelectedPage("contactnumber")}>Contact Number</li>
          

        </ul>
      </div>

      {/* Main Content */}
      <div className="contentContainer">{renderContent()}</div>
    </div>
  );
};

export default SettingsSideBar;
